import { Button, Card, Col, Row, Statistic } from 'antd';
import React from 'react';
import {
    AppstoreOutlined, CameraOutlined, GoldOutlined
  } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getActiveProducts, getOOSProducts, selectAllProductData } from '../../productmanagement/slices/productsSlice';
function DashboardContainer() {
    const navigate = useNavigate();
    const activeProducts = useSelector(getActiveProducts);
    const allProducts = useSelector(selectAllProductData);
    const oosProducts = useSelector(getOOSProducts);

  
  return (
    <Row gutter={[16, 16]}>
      <Col span={8}>
        <Card title="Manage Kogan Products" actions={[

            <Button block type="primary" icon={<AppstoreOutlined/>} onClick={()=>{
                navigate("/products")
            }}>Go</Button>
        ]}>
          <Row gutter={[16,16]}>
            <Col span={12}>

                <Statistic title="Active products" value={activeProducts.length} suffix={`/${allProducts.length}`}/>
            </Col>
            <Col span={12}>

                <Statistic title="Out of Stock Products" value={oosProducts.length} suffix={`/${allProducts.length}`} />
            </Col>
          </Row>

        </Card>
      </Col>
      <Col span={8}>
        <Card title="Manage Kogan Orders" actions={[
        <Button block type="primary" icon={<GoldOutlined/>} onClick={()=>{
                navigate("/orders")
            }}>Goto Order Management</Button>]}>
        </Card>
      </Col>
      <Col span={8}>
        <Card title="Manage Product Images" actions={[
        <Button block type="primary"  icon={<CameraOutlined/> } onClick={()=>{
                navigate("/images")
            }}>Goto Image Management</Button>]}>
        </Card>
      </Col>
    </Row>
  );
}

export default DashboardContainer;
